/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { format } from 'date-fns';
/**
 * A version of getYearsPeriod copied from https://github.com/Hacker0x01/react-datepicker/blob/main/src/date_utils.ts
 */
export function getYearsPeriodString(date, yearItemNumber = 12) {
    const endPeriod = Math.ceil(+format(date, 'yyyy') / yearItemNumber) * yearItemNumber;
    const startPeriod = endPeriod - (yearItemNumber - 1);
    return `${startPeriod}-${endPeriod}`;
}
export const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();
//# sourceMappingURL=utils.js.map